import { createEntityAdapter, EntityState } from '@ngrx/entity';

export enum CobrowsingSessionState {
  pending = 'pending',
  authorizing = 'authorizing',
  active = 'active',
  ended = 'ended',
}

export enum CobrowsingMessageKey {
  CLOSED_BY_CONTACT = 'CLOSED_BY_CONTACT',
  CLOSED_BY_CSR = 'CLOSED_BY_CSR',
  INVALID_ACCOUNT_KEY = 'INVALID_ACCOUNT_KEY',
  NO_MORE_SESSIONS_AVAILABLE = 'NO_MORE_SESSIONS_AVAILABLE',
  REFUSED_BY_CONTACT = 'REFUSED_BY_CONTACT',
  REFUSED_BY_CSR = 'REFUSED_BY_CSR',
  PENDING = 'PENDING',
  TIMEOUT = 'TIMEOUT',
  UNKNOWN_CODE = 'UNKNOWN_CODE',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export enum ToolName {
  drawing = 'drawing',
  laser = 'laser',
}

export interface CobrowsingInfo {
  readonly bookingId: string;
  readonly sessionCode?: string;
  readonly sessionId?: string;
  readonly jwt?: string;
  readonly sessionState?: CobrowsingSessionState;
  readonly errorMessageKey?: CobrowsingMessageKey;
}

export interface CobrowsingSessions extends EntityState<CobrowsingInfo> {}

export const adapter = createEntityAdapter<CobrowsingInfo>({
  selectId: ({ bookingId }) => bookingId,
});

export const initialCobrowsingSessions: CobrowsingSessions = adapter.getInitialState();
